import { APP_DOMAIN } from '../../core/utils/config';

export const testimonialsData = [
  {
    id: 1,
    name: "Bruno Urbano",
    profession: "Software Developer",
    rating: 5,
    feedback: `${APP_DOMAIN} made creating my professional portfolio incredibly easy. The templates are beautiful and the editing process is so intuitive. I had my website up and running in just a few hours!`
  },
  {
    id: 2,
    name: "Maria Theresa Montalvão",
    profession: "Product Manager",
    rating: 5,
    feedback: `As a product manager, I'm very particular about aesthetics. ${APP_DOMAIN} exceeded my expectations with its clean, modern templates and customization options. Highly recommend it to anyone looking to showcase their work professionally.`
  },
  {
    id: 3,
    name: "Willian Rotinguer",
    profession: "Software Developer",
    rating: 5,
    feedback: `I needed a professional website quickly for my job search, and ${APP_DOMAIN} delivered perfectly. The platform is user-friendly, and the final result looks like it was designed by a professional agency.`
  }
];